import React from "react";
import { NotificationManager } from "react-notifications";
import {
  PANELS_STREETLIGHTS_INFO_LOADING_ACTION,
  PANELS_STREETLIGHTS_INFO_SUCCESS_ACTION,
  PANELS_STREETLIGHTS_INFO_FAILURE_ACTION,
} from "../actions/dashboard.action";

const initialState = {
  panelsStreetlightsInfo: {
    slcCnt: 0,
    slcOnCnt: 0,
    slcOffCnt: 0,
    slcNcCnt: 0,
    slcErrCnt: 0,
    lmpCnt: 0,
    lmpOnCnt: 0,
    lmpOffCnt: 0,
    modes: {},
    inpFaults: {},
    outFaults: {},
    othFaults: {}
  },
  panelsStreetlightsInfoAPILoading: false,
  panelsStreetlightsInfoAPIFailure: false,
};

export default function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case PANELS_STREETLIGHTS_INFO_LOADING_ACTION: {
        return {
            ...state,
            panelsStreetlightsInfoAPILoading: true,
            panelsStreetlightsInfoAPIFailure: false
        };
    }
    case PANELS_STREETLIGHTS_INFO_FAILURE_ACTION: {
        return {
            ...state,
            panelsStreetlightsInfoAPILoading: false,
            panelsStreetlightsInfoAPIFailure: true
        };
    }
    case PANELS_STREETLIGHTS_INFO_SUCCESS_ACTION: {
        const { payload } = action;
        return {
            ...state,
            panelsStreetlightsInfo: payload,
            panelsStreetlightsInfoAPILoading: false,
            panelsStreetlightsInfoAPIFailure: false
        };
    }
  }
  return state;
}
